import React from "react";

function GovtJobTable(props){

  var { postLink, job, application_last_date, total_vacancies } = props;
  
  return <div className="row" style={{ ...props.style, borderBottom: '1px solid var(--color-border)'}}>
  <div className="table_url"><a href={String(process.env.REACT_APP_BASE_URL)+String(postLink)} className="title-link" style={{fontSize : "var(--font-size-lg)"}} target="_blank" rel="noreferrer">{job}</a> </div>
  <div className="line2" style={{ display: 'flex', textAlign : 'center'}}>
    <div style={{ flex: 1 }}><strong className="table_last_date" style={{fontSize : "var(--font-size-sm)"}}> Last Date : {application_last_date} </strong></div>
    <div style={{ flex: 1 }}><strong className="table_vacancy" style={{fontSize : "var(--font-size-sm)"}}>Vacancies : {total_vacancies} </strong></div>
    
  </div>
  </div>
}

export default GovtJobTable;